import React from 'react'

const ImageLoader = () => {
  return (
    <div
    className="modal loaderbg"
    id="uploadImageLoaderModal"
    tabIndex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog review-image-loader" role="document">
      <div className="loadingio-spinner-heart-btbrqan8295">
        <div className="ldio-kv0ui0pfesk">
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ImageLoader